import React from "react";

import { graphql, useStaticQuery } from "gatsby";
import * as FooterLandingPageStyles from "./footer-landing-page.module.scss";
import Image from "../../../components/Image";

const FooterLandingPage = () => {
  const {
      wp: {
        acfOptionsFooter: {
          footer: {
            top: { footerLogo },
            bottom: { footerTxtBottom },
          },
        },
        acfOptionsSocials: {
          socials: { socials },
        },
        acfOptionsTema: {
          opzioniTema: {
            generali: { numeroVerde },
          },
        },
      },
    } = useStaticQuery(graphql`
      {
        wp {
          acfOptionsSocials {
            socials {
              socials: social {
                link
                icona {
                  altText
                  localFile {
                    extension
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                  width
                  height
                  title
                }
              }
            }
          }
          acfOptionsTema {
            opzioniTema {
              generali {
                numeroVerde
              }
            }
          }
          acfOptionsFooter {
            footer {
              top {
                footerLogo: logo {
                  altText
                  localFile {
                    extension
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                  width
                  height
                  title
                }
              }
              bottom {
                footerTxtBottom: testo
              }
            }
          }
        }
      }
    `);

  return (
    <footer className={FooterLandingPageStyles.footer}>
      <div className={FooterLandingPageStyles.footerTopSection}>
        <div className={FooterLandingPageStyles.footerLogoContainer}>
          <Image data={footerLogo} />
        </div>
        {socials.length && (
          <div className={FooterLandingPageStyles.footerSocialsLinksContainer}>
            {socials.map((social, i) => {
              return (
                <a
                  key={i}
                  href={social.link}
                  tabIndex="0"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image data={social.icona} className={FooterLandingPageStyles.footerSocialLinks}/>
                </a>
              );
            })}
          </div>
        )}
          {numeroVerde.length && (
            <a
              href={`tel:${numeroVerde}`}
              rel="noreferrer"
              className={FooterLandingPageStyles.footerNumeroVerdeContainer}
            >
              <img
                src="/icon-phone.svg"
                alt="cornetta telefonica"
                width="42"
                height="42"
              />
              <div className={FooterLandingPageStyles.footerNumeroVerdeTextContainer}>
                <p>Numero verde</p>
                <p className={FooterLandingPageStyles.footerNumeroVerdeText}>{numeroVerde}</p>
              </div>
            </a>
          )}
      </div>
      <div className={FooterLandingPageStyles.footerBottomSection}>
        {footerTxtBottom && (
          <p>{footerTxtBottom}</p>
        )}
      </div>
    </footer>
  );
};

export default FooterLandingPage;